export interface VoterRegistrationInfo {
    voter_id: string | null
    verified_voter: boolean | null
    online_registration_url?: string | null
    paper_form_url_en?: string | null
    paper_form_url_es?: string | null
    status_url?: string | null
    address?: string | null
    state?: string | null
}

export const RegistrationType = {
    ONLINE: "online",
    PAPER: "paper",
} as const

export type RegistrationTypeValue = (typeof RegistrationType)[keyof typeof RegistrationType]

export interface RegistrationActionConfig {
    campaignId: number
    supporterId: number
    organizationId: number
    actionCenterResourceUri: string
}

export interface NotRegisteredToVoteProps {
    voterInfo: VoterRegistrationInfo
    registrationActionConfig: RegistrationActionConfig
}
